import { styled, TextField } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginRight: theme.spacing(4),
  marginBottom: theme.spacing(6),
  borderRadius: theme.spacing(2),
}));
